export const teamSections = [
  // 1 — світла класична, 3 колонки
  `<section id="team1" class="bg-light py-5 text-center">
    <div class="container">
      <h2 class="h6 text-primary text-uppercase mb-2">Команда</h2>
      <h3 class="fw-bold h2 mb-4">Хто стоїть за WhiteEx</h3>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <div class="bg-white rounded-3 shadow-sm p-4 h-100">
            <h4 class="fw-bold text-dark mb-1">Олександр Р.</h4>
            <p class="text-secondary small mb-2">Керівник проєкту</p>
            <p class="text-muted">Відповідає за розвиток функціоналу, структурування процесів та стратегічне планування системи WhiteEx.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="bg-white rounded-3 shadow-sm p-4 h-100">
            <h4 class="fw-bold text-dark mb-1">Марина К.</h4>
            <p class="text-secondary small mb-2">Фінансовий аналітик</p>
            <p class="text-muted">Розробляє моделі обліку, контролює якість даних та допомагає клієнтам інтегрувати рішення WhiteEx у роботу.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="bg-white rounded-3 shadow-sm p-4 h-100">
            <h4 class="fw-bold text-dark mb-1">Іван Л.</h4>
            <p class="text-secondary small mb-2">Frontend Developer</p>
            <p class="text-muted">Створює інтерфейси та забезпечує зручність користувачів у щоденній роботі з цифровими модулями WhiteEx.</p>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 2 — темна версія з карточками в рамці
  `<section id="team2" class="bg-dark text-white py-5">
    <div class="container text-center">
      <h2 class="h6 text-warning text-uppercase mb-2">Наша команда</h2>
      <h3 class="fw-bold h2 mb-4">Люди, що створюють структуру</h3>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <div class="border border-secondary rounded-3 p-4 h-100">
            <h4 class="fw-bold text-warning mb-1">Наталія Б.</h4>
            <p class="small mb-2">Координатор клієнтів</p>
            <p class="text-light">Організовує комунікацію між клієнтами та технічною командою, забезпечує своєчасну підтримку та якість сервісу.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="border border-secondary rounded-3 p-4 h-100">
            <h4 class="fw-bold text-warning mb-1">Микола С.</h4>
            <p class="small mb-2">Backend Engineer</p>
            <p class="text-light">Розробляє логіку даних і структуру API, створює надійні процеси для стабільної роботи системи WhiteEx.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="border border-secondary rounded-3 p-4 h-100">
            <h4 class="fw-bold text-warning mb-1">Софія Т.</h4>
            <p class="small mb-2">UI/UX Designer</p>
            <p class="text-light">Проєктує інтерфейси та користувацький досвід, роблячи роботу з платформою зрозумілою та приємною.</p>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 3 — мінімалістична монохромна з описом у центрі
  `<section id="team3" class="bg-white py-5 text-center">
    <div class="container">
      <h2 class="h6 text-uppercase text-muted mb-2">Команда WhiteEx</h2>
      <h3 class="fw-bold h2 mb-4 text-dark">Об’єднані структурою та ідеєю</h3>
      <p class="text-secondary mb-5">Кожен член команди WhiteEx працює над тим, щоб цифрові процеси стали прозорими, зрозумілими й ефективними. Ми цінуємо системність, точність і методичний підхід.</p>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <div class="border rounded-3 shadow-sm p-4 h-100">
            <h4 class="fw-bold text-dark mb-1">Олена М.</h4>
            <p class="small text-secondary mb-2">Data Analyst</p>
            <p class="text-muted">Перетворює дані на зрозумілі звіти, формує аналітичні модулі та перевіряє точність обчислень.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="border rounded-3 shadow-sm p-4 h-100">
            <h4 class="fw-bold text-dark mb-1">Дмитро Г.</h4>
            <p class="small text-secondary mb-2">System Architect</p>
            <p class="text-muted">Будує технічну архітектуру WhiteEx, оптимізує процеси та контролює якість інтеграцій.</p>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="border rounded-3 shadow-sm p-4 h-100">
            <h4 class="fw-bold text-dark mb-1">Ірина П.</h4>
            <p class="small text-secondary mb-2">Support Lead</p>
            <p class="text-muted">Забезпечує стабільну підтримку користувачів, координує відповіді та систематизує запити клієнтів.</p>
          </div>
        </div>
      </div>
    </div>
  </section>`,
];
